import { EntityModel } from '@/interfaces'
import {
  ALL_BUS_SETTINGS_QUERY,
  CREATE_BUS_SETTINGS_MUTATION,
  DELETE_BUS_SETTINGS_MUTATION,
  FORCE_DELETE_BUS_SETTINGS_MUTATION,
  SINGLE_BUS_SETTINGS_QUERY,
  UPDATE_BUS_SETTINGS_MUTATION,
} from './graphql'

const travelServiceBusSettingsModel: EntityModel = {
  name: 'busSettings',
  namePlural: 'busSettings',
  uniqueName: 'travelServiceBusSettings',
  uniqueNamePlural: 'travelServiceBusSettings',
  path: 'travel/pricing/services/bus_settings',
  baseUrl: '/travel/pricing/services/bus_settings',
  translationPrefix: 'entities:travelServiceBusSettings.',
  getDisplayName: (values: any) => {
    return 'TRAVEL SERVICE BUS SETTINGS'
  },
  gql: {
    getAll: ALL_BUS_SETTINGS_QUERY,
    getSingle: SINGLE_BUS_SETTINGS_QUERY,
    create: CREATE_BUS_SETTINGS_MUTATION,
    update: UPDATE_BUS_SETTINGS_MUTATION,
    delete: DELETE_BUS_SETTINGS_MUTATION,
    forceDelete: FORCE_DELETE_BUS_SETTINGS_MUTATION,
  },
  attributes: {
    boardingSelectionEnabled: {
      name: 'boardingSelectionEnabled',
      label: 'entities:travelServiceBusSettings.attributes.boardingSelectionEnabled.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'select',
      selectOptions: [
        {
          label: 'entities:travelServiceBusSettings.attributes.boardingSelectionEnabled.selectOptions.true.label',
          value: 'true',
        },
        {
          label: 'entities:travelServiceBusSettings.attributes.boardingSelectionEnabled.selectOptions.false.label',
          value: 'false',
        },
      ],
      validationType: 'string',
      validations: [],
    },
  },
}

export default travelServiceBusSettingsModel
